// extracted by mini-css-extract-plugin
export default {"basic-panel":"ModalDeleteCompany_basic-panel__UpSpn","title":"ModalDeleteCompany_title__Rjofb","text":"ModalDeleteCompany_text__0HX18"};